/** English of the game data (ADR 0069, step 3), keyed by the exact French text. See `index.ts`. */
export const DATA_WORLD: Readonly<Record<string, string>> = {
  'Chasse aux nuisibles': 'Pest Control',
  'Vaincre 25 rats': 'Defeat 25 rats',
  'Rusé comme un renard': 'Sly as a Fox',
  'Vaincre 25 renards': 'Defeat 25 foxes',
  'Groin pour groin': 'Snout for Snout',
  'Vaincre 25 sangliers': 'Defeat 25 boars',
  'La peste soit du rat': 'A Plague on Rats',
  'Vaincre le Rat pesteux': 'Defeat the Plague Rat',
  Cicatrices: 'Scars',
  'Vaincre le Sanglier balafré': 'Defeat the Scarred Boar',
  'Nez de fer': 'Nose of Iron',
  'Vaincre Groin-de-Fer': 'Defeat Ironsnout',
  'Moisson maudite': 'Cursed Harvest',
  'Vaincre le Grand Épouvantail': 'Defeat the Great Scarecrow',
  'Pierre de voyage': 'Waystone',
  'Activer le portail de Havrebourg': 'Activate the Havrebourg portal',
  Fouineur: 'Snoop',
  'Ouvrir un coffre caché de la région': "Open one of the region's hidden chests",
  'Pillard de camp': 'Camp Raider',
  'Nettoyer un camp de monstres et ouvrir son coffre': 'Clear a monster camp and open its chest',
  'Maître de la Prairie': 'Master of the Meadow',
  'Accomplir tous les succès de la région': 'Complete every achievement in the region',
  'Gardien de la Prairie': 'Meadow Keeper',
  'La meute': 'The Pack',
  'Vaincre 30 loups': 'Defeat 30 wolves',
  Bûcheron: 'Lumberjack',
  'Vaincre 30 sylvains': 'Defeat 30 treants',
  'Chasseur de gobelins': 'Goblin Hunter',
  'Vaincre 30 gobelins': 'Defeat 30 goblins',
  'Tir de barrage': 'Barrage',
  'Vaincre 30 archers gobelins': 'Defeat 30 goblin archers',
  Cendres: 'Ashes',
  'Vaincre le Loup cendré': 'Defeat the Ash Wolf',
  'Décapiter la horde': 'Behead the Horde',
  'Vaincre le Chef gobelin': 'Defeat the Goblin Chief',
  'Croc brisé': 'Broken Fang',
  'Vaincre Croc-d’Argent': 'Defeat Silverfang',
  'Nuit de pleine lune': 'Full Moon Night',
  'Vaincre le Loup-Garou': 'Defeat the Werewolf',
  'Activer le portail de Sylvebois': 'Activate the Sylvebois portal',
  'Maître de la Forêt': 'Master of the Forest',
  'Veilleur des Murmures': 'Whisper Warden',
  Coassements: 'Croaks',
  'Vaincre 35 crapauds géants': 'Defeat 35 giant toads',
  Maroquinier: 'Leatherworker',
  'Vaincre 35 caïmans': 'Defeat 35 caimans',
  Écailles: 'Scales',
  'Vaincre 35 hommes-lézards': 'Defeat 35 lizardmen',
  'Éteindre les lueurs': 'Snuff the Lights',
  'Vaincre 35 feux follets': "Defeat 35 will-o'-wisps",
  Antidote: 'Antidote',
  'Vaincre le Crapaud venimeux': 'Defeat the Venom Toad',
  'Silence, sorcier': 'Hush, Sorcerer',
  'Vaincre le Chaman lézard': 'Defeat the Lizard Shaman',
  Régicide: 'Regicide',
  'Vaincre le Roi des Tourbières': 'Defeat the Bog King',
  'Sous le pont': 'Under the Bridge',
  'Vaincre le Troll des Tourbières': 'Defeat the Bog Troll',
  'Activer le portail de Brumevase': 'Activate the Brumevase portal',
  'Maître du Marais': 'Master of the Swamp',
  'Seigneur des Brumes': 'Lord of the Mists',
  'Rires étouffés': 'Muffled Laughter',
  'Vaincre 40 hyènes': 'Defeat 40 hyenas',
  'Dard pour dard': 'Sting for Sting',
  'Vaincre 40 scorpions géants': 'Defeat 40 giant scorpions',
  Pompier: 'Firefighter',
  'Vaincre 40 salamandres de braise': 'Defeat 40 ember salamanders',
  'Vaincre 40 momies': 'Defeat 40 mummies',
  Charmeur: 'Snake Charmer',
  'Vaincre 40 cobras cracheurs': 'Defeat 40 spitting cobras',
  Galeux: 'Mangy',
  'Vaincre la Hyène galeuse': 'Defeat the Mangy Hyena',
  'Brise-malédiction': 'Curse Breaker',
  'Vaincre la Momie maudite': 'Defeat the Cursed Mummy',
  Mémoire: 'Remembrance',
  'Vaincre le Pharaon oublié': 'Defeat the Forgotten Pharaoh',
  'Or terni': 'Tarnished Gold',
  'Vaincre le Chacal d’Or': 'Defeat the Golden Jackal',
  'Activer le portail de Sablerouge': 'Activate the Sablerouge portal',
  'Maître du Désert': 'Master of the Desert',
  'Enfant de la Braise': 'Child of the Embers',
  Hurlements: 'Howls',
  'Vaincre 50 loups des glaces': 'Defeat 50 ice wolves',
  Fourreur: 'Furrier',
  'Vaincre 50 ours blancs': 'Defeat 50 polar bears',
  Dégel: 'Thaw',
  'Vaincre 50 revenants du givre': 'Defeat 50 frost revenants',
  'Il existe': "It's Real",
  'Vaincre 50 yétis': 'Defeat 50 yetis',
  Plumée: 'Plucked',
  'Vaincre 50 harpies des neiges': 'Defeat 50 snow harpies',
  Hibernation: 'Hibernation',
  'Vaincre l’Ours des glaces': 'Defeat the Ice Bear',
  Silence: 'Silence',
  'Vaincre le Yéti hurleur': 'Defeat the Howling Yeti',
  'Fin de la tempête': 'End of the Storm',
  'Vaincre le Vieux Blizzard': 'Defeat Old Blizzard',
  'Le trône est vide': 'The Throne Is Empty',
  'Vaincre le Géant de Givre': 'Defeat the Frost Giant',
  'Activer le portail de Givrecime': 'Activate the Givrecime portal',
  'Maître des Pics': 'Master of the Peaks',
  'Vainqueur des Pics': 'Peak Conqueror',
  Dératisation: 'Extermination',
  'Vaincre 500 rats': 'Defeat 500 rats',
  Dératiseur: 'Ratcatcher',
  'Fléau des loups': 'Bane of Wolves',
  'Vaincre 300 loups de toute espèce': 'Defeat 300 wolves of any kind',
  'Fléau des Loups': 'Wolfbane',
  'Chasse aux trophées': 'Trophy Hunt',
  'Vaincre 30 élites': 'Defeat 30 elites',
  'Traqueur d’Élites': 'Elite Tracker',
  'Carnet bien tenu': 'A Well-Kept Log',
  'Mener 10 pages du carnet de chasse au palier 10': 'Bring 10 hunting log pages to tier 10',
  Pisteur: 'Tracker',
  'Chasseur aguerri': 'Seasoned Hunter',
  'Mener 5 pages du carnet de chasse au palier 100': 'Bring 5 hunting log pages to tier 100',
  Traqueur: 'Stalker',
  'Fléau des bêtes': 'Bane of Beasts',
  'Mener une page du carnet de chasse au palier 1 000': 'Bring one hunting log page to tier 1,000',
  'Fléau des Bêtes': 'Beastbane',
  'Tueur de titans': 'Titan Slayer',
  'Vaincre 25 boss de région': 'Defeat 25 region bosses',
  'Tueur de Titans': 'Titan Slayer',
  'Chasseur de rares': 'Rare Hunter',
  'Vaincre 5 monstres rares': 'Defeat 5 rare monsters',
  'Chasseur de Rares': 'Rare Hunter',
  Massacre: 'Massacre',
  'Vaincre 5 000 ennemis': 'Defeat 5,000 enemies',
  Massacreur: 'Butcher',
  Increvable: 'Unkillable',
  'Tomber 50 fois': 'Fall 50 times',
  'Habitué du Cimetière': 'Graveyard Regular',
  'Semelles usées': 'Worn Soles',
  'Parcourir 50 000 cases': 'Walk 50,000 tiles',
  'Grand Voyageur': 'Great Traveler',
  'Poches pleines': 'Full Pockets',
  'Ramasser 1 000 objets': 'Pick up 1,000 items',
  'Cri de guerre': 'War Cry',
  'Lancer 1 000 sorts': 'Cast 1,000 spells',
  'Les Cinq Terres': 'The Five Lands',
  'Accomplir tous les succès des cinq régions': 'Complete every achievement in all five regions',
  'Conquérant des Cinq Terres': 'Conqueror of the Five Lands',
  'Bêta-testeur': 'Beta Tester',
  'Avoir joué à Shefira pendant sa bêta': 'Played Shefira during its beta',
  Prairie: 'Meadow',
  Havrebourg: 'Havrebourg',
  'Écuries de Havrebourg': 'Havrebourg Stables',
  'Forêt des Murmures': 'Whispering Forest',
  Sylvebois: 'Sylvebois',
  'Marais Brumeux': 'Misty Marsh',
  Brumevase: 'Brumevase',
  'Désert de Braise': 'Ember Desert',
  Sablerouge: 'Sablerouge',
  'Relais des chameliers': "Camel Drivers' Post",
  'Pics Gelés': 'Frozen Peaks',
  Givrecime: 'Givrecime',
  'D’ici, je vois ma vieille tour. Le nouveau guetteur dort à son poste, je le vois très bien !':
    'From here I can see my old tower. The new lookout is asleep at his post; I can see him perfectly!',
  'Il n’y a pas un seul arbre dans ce quartier ! Je vais en planter un. Ser Givrecoeur a dit oui. Enfin, je crois.':
    "There isn't a single tree in this quarter! I'm going to plant one. Ser Givrecoeur said yes. Well, I think he did.",
  'Trois cordes, deux harpons et un filet. Il m’en faudrait le double pour un dragon !':
    "Three ropes, two harpoons and a net. I'd need twice as much for a dragon!",
  'J’ai allumé un brasero dans la cour. Si je m’absente, ne le laisse surtout pas s’éteindre !':
    "I've lit a brazier in the yard. If I'm away, whatever you do, don't let it go out!",
  'Givrecoeur ronfle. Il ronflait déjà quand on était petits, ça ne s’est pas arrangé.':
    "Givrecoeur snores. He already snored when we were kids; it hasn't got any better.",
  'Quartier de la Compagnie': 'Company Quarter',
  'Ramène-moi des gens courageux, recrue. Des gens qui n’ont pas peur du froid !':
    "Bring me brave people, recruit. People who aren't afraid of the cold!",
  'Les renards m’ont encore pris deux poules cette semaine. Et l’autre nuit, j’ai vu une lumière rouge au nord, derrière les champs. Ma femme dit que c’est un feu de berger. Mais un feu de berger, ça n’éclaire pas les nuages, si ?':
    "The foxes took two more of my hens this week. And the other night, I saw a red light to the north, past the fields. My wife says it's a shepherd's fire. But a shepherd's fire doesn't light up the clouds, does it?",
  'Mont Moussu': 'Mossy Mount',
  'Pic des Ramures': 'Antler Peak',
  'Tanière des Loups': "Wolves' Den",
  'Roc aux Loups': 'Wolf Rock',
  'Cimetière Englouti': 'Sunken Graveyard',
  'Ruines Noyées': 'Drowned Ruins',
  'Grotte des Hyènes': 'Hyena Cave',
  'Obélisque Oublié': 'Forgotten Obelisk',
  'Cristaux du Givre': 'Frost Crystals',
  "Caverne de l'Ours": "Bear's Cavern",
  'Crête du Givre': 'Frost Ridge',
  'Une lame d’obsidienne dévorée par les flammes, portée par-dessus ton arme. Animée.':
    'An obsidian blade devoured by flames, worn over your weapon. Animated.',
  'Un chien de braise fendu de lave qui trotte à ta droite, la queue en feu. Animé.':
    'A lava-veined ember hound that trots at your right, its tail on fire. Animated.',
  'Une monture de lave et de flammes, deux fois plus rapide que tes jambes. Animée.':
    'A mount of lava and flame, twice as fast as your own two legs. Animated.',
  'Obsidienne fendue de lave, deux cornes, une crête de flammes. Animé.':
    'Lava-veined obsidian, twin horns, a crest of flames. Animated.',
  'Plaques de pierre volcanique, braise au cœur, flammes aux épaules. Animée.':
    'Volcanic stone plates, embers at the heart, flames at the shoulders. Animated.',
  'Des poings d’obsidienne aux jointures de braise. Animés.':
    'Obsidian fists with glowing ember knuckles. Animated.',
  'Chaque pas laisse monter une flamme des chevilles. Animées.':
    'Every step sends a flame curling up from your ankles. Animated.',
  'Un disque d’obsidienne cerclé de feu, la braise au centre. Animé.':
    'An obsidian disc ringed with fire, embers at its center. Animated.',
  'Des ailes d’obsidienne fendues de lave, les pointes en feu, dans ton dos. Animées.':
    'Lava-veined obsidian wings with burning tips, spread across your back. Animated.',
  'Pack fondateur': 'Founder Pack',
  'La panoplie complète de ceux qui étaient là au début : les six pièces de flamme, les ailes de flamme, le chien de feu à tes côtés et le cheval de feu sous ta selle.':
    'The complete set for those who were there from the start: all six flame pieces, the flame wings, the fire hound at your side and the fire horse under your saddle.',
  'Un cheval ailé d’un blanc de neige, la crinière au vent, qui te porte trois fois et demie plus vite que tes jambes.':
    'A snow-white winged horse, mane in the wind, that carries you three and a half times faster than your own legs.',
  'Une lame rouge sang à la garde d’écailles, portée par-dessus ton arme.':
    'A blood-red blade with a scaled guard, worn over your weapon.',
  'Un heaume d’écailles rouges aux cornes recourbées.': 'A helm of red scales with curling horns.',
  'Des plaques d’écailles rouges et or sur les épaules et le torse.':
    'Plates of red and gold scales across the shoulders and chest.',
  'Des griffes d’écailles rouges aux poings.': 'Red-scaled claws for your fists.',
  'Des bottes d’écailles rouges aux chevilles griffues.': 'Red-scaled boots with clawed ankles.',
  'Un écu d’écailles rouges frappé d’une tête de dragon.':
    "A red-scaled shield emblazoned with a dragon's head.",
  'Des ailes de cuir cramoisi aux os liserés d’or, qui battent dans ton dos. Animées.':
    'Crimson leather wings with gold-trimmed bones, beating at your back. Animated.',
  'Pack du Dragon': 'Dragon Pack',
  'Un petit chat d’un noir de jais aux yeux jaunes, qui trotte à ta droite sans un bruit.':
    'A little jet-black cat with yellow eyes, trotting silently at your right.',
  'Une petite gelée translucide qui rebondit à tes côtés et ramasse ton butin.':
    'A little translucent jelly that bounces at your side and picks up your loot.',
  'Un golem de pierre grand comme un chien, la mousse aux épaules, les yeux luisants.':
    'A stone golem the size of a dog, moss on its shoulders, its eyes glowing.',
  'Un bébé yéti tout en fourrure blanche, qui te suit en se dandinant.':
    'A baby yeti all in white fur, waddling along behind you.',
  'Un grand loup sombre sous une selle de guerre en cuir et fer, qui te porte deux fois et demie plus vite que tes jambes.':
    'A great dark wolf under a leather-and-iron war saddle, carrying you two and a half times faster than your legs.',
  'De grandes ailes de monarque, orange veiné de noir et semé de points blancs, qui battent dans ton dos. Animées.':
    'Large monarch wings, orange veined with black and dotted with white, beating at your back. Animated.',
  'Des ailes de plumes blanches au liseré d’or, qui s’ouvrent doucement dans ton dos. Animées.':
    'White feathered wings with a golden rim, slowly spreading at your back. Animated.',
  'De fines ailes de cuir noir aux bords festonnés, qui claquent dans ton dos. Animées.':
    'Thin black leather wings with scalloped edges, snapping at your back. Animated.',
  'Une lame taillée dans une améthyste, violette et translucide, portée par-dessus ton arme.':
    'A blade cut from an amethyst, violet and translucent, worn over your weapon.',
  'Une lance de guerre qui porte ta bannière pourpre frappée d’une étoile d’or, par-dessus ton arme.':
    'A war spear bearing your crimson banner with a golden star, worn over your weapon.',
  'Un poireau géant, frais du potager, tenu comme une épée. Tes ennemis ne s’en remettront pas.':
    'A giant leek, fresh from the garden, wielded like a sword. Your foes will never get over it.',
  'Chaque pas soulève des braises qui montent en tourbillonnant avant de s’éteindre.':
    'Every step stirs up embers that swirl upward before dying out.',
  'Le sol gèle sous tes pas : des éclats de givre scintillent un instant derrière toi.':
    'The ground freezes beneath your feet: shards of frost glitter for a moment behind you.',
  'Des pétales tombent autour de toi à chaque pas et se posent sur ton chemin.':
    'Petals fall around you with every step and settle along your path.',
  'Des feuilles d’automne tourbillonnent dans ton sillage, où que tu marches.':
    'Autumn leaves swirl in your wake, wherever you walk.',
  'Des étoiles d’or et de glace s’allument à chacun de tes pas et montent en scintillant.':
    'Stars of gold and ice light up with every step and rise, twinkling.',
  'Des cendres de wyrm s’envolent derrière toi, certaines encore rougeoyantes.':
    'Wyrm ashes fly up behind you, some still glowing red.',
  'Brins de paille et plumes de corbeau roulent dans ton sillage.':
    'Wisps of straw and crow feathers tumble in your wake.',
  'Des lucioles s’éveillent sous tes pas et s’élèvent en clignotant.':
    'Fireflies wake beneath your feet and rise, blinking.',
  'Des spores luminescentes montent de chaque empreinte, comme au fond des tourbières.':
    'Glowing spores rise from every footprint, as in the depths of the bogs.',
  'De petits tourbillons de sable dansent derrière toi, comme un mirage.':
    'Little whirls of sand dance behind you, like a mirage.',
  'Des flocons tourbillonnent autour de toi et se posent sur ton chemin.':
    'Snowflakes swirl around you and settle along your path.',
  'Les six pièces du set du dragon en apparence (épée, heaume, plastron, gantelets, bottes et bouclier) et ses ailes, par-dessus ton équipement.':
    'The six pieces of the dragon set as a look (sword, helm, chestplate, gauntlets, boots and shield) plus its wings, worn over your gear.',
  Fondateur: 'Founder',
  'Cœur de Dragon': 'Dragonheart',
  'L’Épouvantail qui marche': 'The Walking Scarecrow',
  'Une citrouille sculptée, une chandelle qui vacille derrière les yeux. Animée.':
    'A carved pumpkin, a candle flickering behind its eyes. Animated.',
  'Un pourpoint rapiécé, bourré de paille qui dépasse aux coutures.':
    'A patched jerkin, stuffed with straw poking out at the seams.',
  'De vieux gants de toile, la paille qui sort aux poignets.':
    'Old cloth gloves, straw spilling out at the wrists.',
  'Des bottes usées jusqu’à la corde, la paille aux chevilles.':
    'Boots worn threadbare, straw at the ankles.',
  'Une faux rouillée au manche noueux, portée par-dessus ton arme.':
    'A rusty scythe with a gnarled handle, worn over your weapon.',
  'Une lanterne de fer où danse une flamme orange. Animée.':
    'An iron lantern with an orange flame dancing inside. Animated.',
  'Un corbeau noir aux yeux de braise qui te suit de champ en champ.':
    'A black crow with ember eyes that follows you from field to field.',
  'Pack de l’Épouvantail': 'Scarecrow Pack',
  'Le costume de la nuit du Grand Épouvantail : la tête de citrouille, les haillons, les gants, les bottes, la faux, la lanterne et le corbeau de minuit.':
    'The costume of the night of the Great Scarecrow: the pumpkin head, the rags, the gloves, the boots, the scythe, the lantern and the midnight crow.',
  'Une lame d’argent blanc où glissent les reflets verts et violets de l’aurore. Animée.':
    'A blade of white silver where the green and violet glints of the aurora glide. Animated.',
  'Un heaume blanc et argent, un joyau de lumière au front, un panache d’aurore. Animé.':
    'A white and silver helm, a jewel of light on the brow, a plume of aurora. Animated.',
  'Plaques blanches et argent, un cœur de lumière qui brille au milieu de la poitrine. Animée.':
    'White and silver plates, a heart of light glowing in the middle of the chest. Animated.',
  'Des poings d’argent blanc où passent les lueurs de l’aurore. Animés.':
    'Fists of white silver where the lights of the aurora pass. Animated.',
  'Des bottes d’argent blanc aux reflets verts et violets. Animées.':
    'Boots of white silver with green and violet glints. Animated.',
  'Un écu blanc cerclé d’argent, la lumière au cœur, l’aurore sur sa face. Animé.':
    'A white shield rimmed with silver, light at its heart, the aurora across its face. Animated.',
  'Deux rideaux de lumière qui ondulent dans ton dos, du vert au violet. Animées.':
    'Two curtains of light rippling at your back, from green to violet. Animated.',
  'Un renard polaire au pelage blanc teinté d’aurore, qui trotte à ta droite. Animé.':
    'A polar fox with white fur tinged by the aurora, trotting at your right. Animated.',
  'Aurore de la Compagnie': 'Aurora of the Company',
  'La lumière de la Compagnie de Havrebourg : les six pièces d’argent blanc aux reflets d’aurore, les ailes de lumière et le renard polaire, par-dessus ton équipement.':
    'The light of the Havrebourg Company: the six pieces of white silver with aurora glints, the wings of light and the polar fox, worn over your gear.',
  'Veilleur de l’Aurore': 'Aurora Watcher',
  'Tueur de Wyrm': 'Wyrmslayer',
  'Le croc d’un wyrm monté sur une garde d’os, gravé de runes rouges qui battent comme un cœur. Animé.':
    'A wyrm’s fang set on a bone guard, carved with red runes that beat like a heart. Animated.',
  'Le crâne blanchi d’un dragon abattu, cornes en arrière, runes rouges dans les orbites. Animé.':
    'The bleached skull of a slain dragon, horns swept back, red runes in its eye sockets. Animated.',
  'Cuir tanné et côtes de dragon sanglées sur le torse, les runes rouges crachant des braises. Animée.':
    'Tanned leather and dragon ribs strapped across the chest, their red runes spitting embers. Animated.',
  'Des gants de cuir aux jointures d’os, une rune rouge qui luit sur chaque poing. Animés.':
    'Leather gloves with bone knuckles and a red rune glowing on each fist. Animated.',
  'Des bottes de cuir aux jambières d’os, où couvent des runes rouges. Animées.':
    'Leather boots with bone greaves where red runes smoulder. Animated.',
  'Une seule écaille, grande comme un homme, arrachée au wyrm et marquée d’une rune ardente. Animée.':
    'A single scale as tall as a man, torn from the wyrm and branded with a burning rune. Animated.',
  'Tête et ailes d’aigle, corps de lion : une monture fière, deux fois plus rapide que tes jambes.':
    'Head and wings of an eagle, body of a lion: a proud mount, twice as fast as your own two legs.',
  'Un faucon chaperonné de cuir qui se tient à ta droite et part chercher ton butin.':
    'A leather-hooded falcon that stands at your right and flies off to fetch your loot.',
  'Pack du Tueur de dragon': 'Dragonslayer Pack',
  'Les trophées d’un wyrm abattu : crâne, cuirasse, gantelets et bottes d’ossements, son croc et son écaille, le griffon sous ta selle et le faucon de chasse à tes côtés.':
    'The trophies of a slain wyrm: bone skull, cuirass, gauntlets and boots, its fang and its scale, the griffon under your saddle and the hunting falcon at your side.',
  'Esprit de la Forêt': 'Spirit of the Forest',
  'Esprit sylvestre': 'Sylvan Spirit',
  'Maître des Tourbières': 'Master of the Bogs',
  'Sorcier des marais': 'Bog Sorcerer',
  'Une racine noueuse arrachée au marais, un feu follet vert pris dans sa tête. Animé.':
    'A gnarled root torn from the marsh, a green will-o’-the-wisp caught in its head. Animated.',
  'Une capuche de mousse où poussent des champignons qui luisent d’un vert d’outre-tombe. Animée.':
    'A mossy hood sprouting mushrooms that glow an eerie, ghostly green. Animated.',
  'Une robe de toile des marais et de mousse, qui sent la tourbe et la pluie.':
    'A robe of bog cloth and moss that smells of peat and rain.',
  'Des gants de toile moussue aux doigts tachés de vase.':
    'Gloves of mossy cloth, their fingers stained with mud.',
  'Des bottes de cuir noyé, faites pour marcher là où l’on s’enfonce.':
    'Boots of drowned leather, made for walking where others sink.',
  'Une vieille lanterne où tremble une flamme verte de feu follet. Animée.':
    'An old lantern where a green will-o’-the-wisp flame flickers. Animated.',
  'Une grenouille des tourbières dont la gorge s’allume comme une lanterne, qui sautille à ta droite. Animée.':
    'A bog frog whose throat lights up like a lantern, hopping along at your right. Animated.',
  'Toute la tenue du sorcier (capuche, robe, gants, bottes, bâton et lanterne) et la grenouille-lanterne à tes côtés, par-dessus ton équipement.':
    "The sorcerer's whole outfit (hood, robe, gloves, boots, staff and lantern) and the lantern frog at your side, worn over your gear.",
  'Une branche vivante taillée en épée, fleurie de la garde à la pointe, portée par-dessus ton arme. Animée.':
    'A living branch shaped into a sword, in bloom from hilt to tip, worn over your weapon. Animated.',
  'Des bois de cerf en fleurs noués de lierre, et des lucioles qui tournent autour. Animée.':
    'Blossoming stag antlers bound with ivy, and fireflies circling around them. Animated.',
  'Écorce et mousse tissées de fleurs, où court une liane vivante.':
    'Bark and moss woven with flowers, laced with a living vine.',
  'Des mains d’écorce enlacées de lierre en fleurs.': 'Bark hands twined with flowering ivy.',
  'Des bottes de racines et de mousse, comme poussées du sol.':
    'Boots of roots and moss, as if grown from the ground.',
  'Des racines tressées en écu autour d’un cœur de mousse lumineuse. Animé.':
    'Roots braided into a shield around a heart of glowing moss. Animated.',
  'Un cerf blanc paré de mousse et de fleurs, qui te porte deux fois plus vite que tes jambes.':
    'A white stag decked in moss and flowers that carries you twice as fast as your own legs.',
  'Toute la parure de la dryade (couronne, cuirasse, gantelets, bottes, lame et bouclier) et le cerf blanc paré de fleurs, par-dessus ton équipement.':
    "The dryad's whole garb (crown, cuirass, gauntlets, boots, blade and shield) and the white stag decked in flowers, worn over your gear.",
  'Seigneur des Mirages': 'Lord of Mirages',
  'Voix des Esprits': 'Voice of the Spirits',
  'Pack du Chaman des pics': 'Shaman of the Peaks Pack',
  'Un totem de bois sculpté d’un visage d’esprit, orné de plumes, porté par-dessus ton arme.':
    'A wooden totem carved with a spirit face and hung with feathers, worn over your weapon.',
  'La tête d’un loup gris portée en capuche, plumes et perle rouge nouées au côté.':
    "A grey wolf's head worn as a hood, feathers and a red bead tied at the side.",
  'Fourrures et peaux peintes de runes d’ocre qui s’éveillent et s’éteignent. Animé.':
    'Furs and hides painted with ochre runes that wake and fade. Animated.',
  'Des plaques d’os liées de fourrure grise, peintes d’une rune rouge.':
    'Bone plates bound with grey fur, painted with a red rune.',
  'De lourdes bottes de loup gris aux attaches d’os, rayées d’ocre rouge.':
    'Heavy grey wolf-fur boots with bone toggles, striped with red ochre.',
  'Une rondache de peau tendue frappée d’une patte rouge, plumes et perles d’os pendues à son bord.':
    'A round shield of stretched hide marked with a red paw, feathers and bone beads hanging from its rim.',
  'Une chouette blanche aux yeux d’or, messagère des esprits, qui vole à ta droite. Animée.':
    'A white owl with golden eyes, messenger of the spirits, flying at your right side. Animated.',
  'Les six pièces du chaman (massue-totem, coiffe, manteau, brassards, bottes et bouclier) et le harfang des neiges, par-dessus ton équipement.':
    "The shaman's six pieces (totem club, headdress, mantle, bracers, boots and shield) and the snowy owl, worn over your gear.",
  'Pack du Djinn des mirages': 'Djinn of Mirages Pack',
  'Une lame courbe d’acier bleu à la garde d’or, portée par-dessus ton arme.':
    'A curved blade of blue steel with a golden guard, worn over your weapon.',
  'Un turban de soie bleu nuit ceint d’or, un joyau d’or au front.':
    'A midnight-blue silk turban banded with gold, a golden jewel on the brow.',
  'Une tunique de soie bleue brodée d’or, nouée d’une ceinture dorée, la fumée aux épaules. Animée.':
    'A gold-embroidered blue silk tunic tied with a golden sash, smoke rising from the shoulders. Animated.',
  'Des brassards d’or d’où s’enroulent des volutes de fumée bleue. Animés.':
    'Golden bracers wreathed in curling wisps of blue smoke. Animated.',
  'Des babouches de soie bleue aux pointes d’or recourbées.':
    'Blue silk slippers with curled golden toes.',
  'Une lampe de laiton poli dont le bec laisse filer une fumée bleue. Animée.':
    'A polished brass lamp trailing blue smoke from its spout. Animated.',
  'Un tapis de soie bleue et or qui flotte au-dessus du sable et te porte deux fois plus vite que tes jambes. Animé.':
    'A carpet of blue and gold silk that floats above the sand and carries you twice as fast as your own legs. Animated.',
  'Les six pièces du djinn (cimeterre, turban, soieries, brassards, babouches et lampe) et le tapis volant, par-dessus ton équipement.':
    "The djinn's six pieces (scimitar, turban, silks, bracers, slippers and lamp) and the flying carpet, worn over your gear.",
  Herbe: 'Grass',
  Sable: 'Sand',
  Neige: 'Snow',
  Marais: 'Marsh',
  Terre: 'Dirt',
  Fourré: 'Thicket',
  Eau: 'Water',
  Marécage: 'Bog',
  Glace: 'Ice',
  Roche: 'Rock',
  Pont: 'Bridge',
  Sommet: 'Summit',
  Grotte: 'Cave',
  Paroi: 'Cave Wall',
  Dalles: 'Flagstones',
  Muraille: 'Rampart',
  Falaise: 'Cliff',
  'Invasion gobeline': 'Goblin Invasion',
  'Élite géante': 'Giant Elite',
  'Chariot d’or': 'Gold Cart',
  'Camp des premiers pas': 'First Steps Camp',
  'Terrain d’entraînement': 'Training Ground',
  'Vers Havrebourg': 'To Havrebourg',
  'Vallée de Shefira': 'Shefira Valley',
  'Cercle des Anciens': 'Circle of Elders',
  'Tour de Guet': 'Watchtower',
  'Camp des Gobelins': 'Goblin Camp',
  'Mont Clair': 'Clear Mount',
  'Butte aux Vents': 'Windy Knoll',
  'Tertre Noyé': 'Drowned Mound',
  'Aiguille de Braise': 'Ember Spire',
  'Galerie sous la Crête du Givre': 'Gallery under Frost Ridge',
  'Caverne sous le Pic des Ramures': 'Cavern under Antler Peak',
  'Dédale sous le Mont Clair': 'Maze under Clear Mount',
  'Grotte sous le Mont Moussu': 'Cave under Mossy Mount',
  'Galerie sous la Butte aux Vents': 'Gallery under Windy Knoll',
  'Caverne sous le Tertre Noyé': 'Cavern under Drowned Mound',
  'Dédale sous le Roc aux Loups': 'Maze under Wolf Rock',
  "Grotte sous l'Aiguille de Braise": 'Cave under Ember Spire',
};
